import $ from "jquery";
import { contentMeta } from "#scripts/general_functions";

export const getImageByContentId = (id, cb) => {
	if (id) {
		const apiCall = `${window.apiUrl}/PublicContentApi/find/${id}`;

		$.getJSON(apiCall).done((data) => {
			const meta = contentMeta(data);
			const img = {
				url: data.path ?? "",
				filename: data.filename ?? "",
				title: data.title ?? "",
				desc: meta.imageDescription ?? "",
				alt: meta.BildeAlternativTekst ?? "",
				copyright: data.mediaCopyright ?? "",
				imageHotspotX: meta.imageHotspotX ?? "",
				imageHotspotY: meta.imageHotspotY ?? "",
			};
			cb(img);
		});
	}
};

export const getImage = (id, all) => {
	let url = "";
	$.each(all, (nr, obj) => {
		if (id === obj.contentId) {
			url = obj.path;
		}
	});
	if (url.includes("preview.sdl.no")) {
		url = url.replace("https://preview.sdl.no", `${window.apiUrl.replace("/api", "")}/proxy/ntbpreview`);
	}
	return `//res.cloudinary.com/ssp/image/fetch/g_auto,w_1200,h_400,c_fill,f_auto/${url}`;
};

export const setResponsiveImage = (_me, _ar = "16:9") => {
	let me = _me;
	let ar = _ar;
	const contentWrapper = document.getElementById("contentHtml");

	// Convert the argument "me" to vanilla js element if it's a jQuery object
	me = convertToVanillaElement(me);
	if (!me) return;

	let url = me.dataset.src;
	url = url.includes("preview.sdl.no") ? url.replace("https://preview.sdl.no", `${window.apiUrl.replace("/api", "")}/proxy/ntbpreview`) : url;
	const hotSpot = me.dataset.imagehotspot;
	let focus = "g_auto:subject";

	if (url && !url.match("res.cloudinary")) {
		let { width, height } = getDimensions(me);
		ar = adjustAspectRatio(ar, width, height, contentWrapper);
		if (hotSpot && !hotSpot.includes("undefined")) {
			$.getJSON(`https://res.cloudinary.com/ssp/image/fetch/fl_getinfo/${url}`).done((data) => {
				const [hotSpotX, hotSpotY] = hotSpot.split(",");
				const x = data.input.width / 2 + (data.input.width / 2) * hotSpotX;
				const y = data.input.height / 2 - (data.input.height / 2) * hotSpotY;
				focus = `g_xy_center,x_${Math.floor(x)},y_${Math.floor(y)}`;
				if (data.input.height === 72 && data.input.width === 72) {
					ar = "1:1"; // BTI icons are 72x72 so we need an exeption for these images
				}
				me.setAttribute("src", `//res.cloudinary.com/ssp/image/fetch/c_fill,w_${width},ar_${ar},${focus}/c_limit,w_1140/${url}`);
			});
		} else {
			me.setAttribute("src", `//res.cloudinary.com/ssp/image/fetch/c_fill,w_${width},ar_${ar},${focus}/c_limit,w_1140/${url}`);
		}
	}
};

const convertToVanillaElement = (me) => {
	if (typeof jQuery === "function" && me instanceof $) {
		return me.get(0);
	} else if (me?.length > 0) {
		return me[0];
	}
	return me;
};

const getDimensions = (me) => {
	let width = 1140; //Math.floor(me.width) || "auto";
	let height = Math.floor(me.height) || Math.floor(width / (16 / 9));

	if (height === 0 && window.serverdata.configMeta.aim.style.module?.campaign__image_height) {
		height = window.serverdata.configMeta.aim.style.module.campaign__image_height;
	}
	if (width === 0 && window.serverdata.configMeta.aim.style.module?.campaign__image_width) {
		width = window.serverdata.configMeta.aim.style.module.campaign__image_width;
	}

	return { width, height };
};

const adjustAspectRatio = (ar, width, height, contentWrapper) => {
	if (width === height) {
		return "1:1";
	}
	if (contentWrapper?.classList.contains("mal_enhetsmal")) {
		return "19:6";
	}
	if (height === 72 && width === 72) {
		return "1:1"; // BTI icons are 72x72 so we need an exception for these images
	}
	return ar;
};

export const setImages = (content) => {
	const html = $(`<div class='article-parse'>${content}</div>`);
	html.find(".gallery img").each(function () {
		const img = $(this);
		let src = img.attr("src");

		img.attr("data-src", src);
		img.attr("data-styles", img.attr("style"));
		img.removeAttr("style");

		if (src.includes("preview.sdl.no")) {
			src = src.replace("https://preview.sdl.no", `${window.apiUrl.replace("/api", "")}/proxy/ntbpreview`);
		}
		img.attr("src", `//res.cloudinary.com/ssp/image/fetch/ar_1.8,w_1140,c_fill,g_auto,f_auto/${src.match(/https/gi) ? src : `${window.location.protocol}/${src}`}`);
		img.addClass("aim--edit aim--gallery");
	});

	html.find("img:not(.aim--gallery)").each(function () {
		let src = $(this).attr("src");
		let url = "";

		if (src.includes("preview.sdl.no")) {
			src = src.replace("https://preview.sdl.no", `${window.apiUrl.replace("/api", "")}/proxy/ntbpreview`);
		}
		url = `https://res.cloudinary.com/ssp/image/fetch/c_fill,g_auto,q_auto,f_auto/${src}`;
		const styles = $(this).attr("style");
		$(this).attr({ "data-src": url, src: url });
		$(this).attr("data-styles", styles);
		$(this).addClass("aim--edit aim--stdimg");
	});
	return html.html();
};

export const setImageText = (content) => {
	$("img.aim--stdimg[longdesc]:not([longdesc=''])").each(function () {
		$(this).wrap(`<div class="article__imgtxt__container" style="${$(this).attr("data-styles") ?? ""}">`);
		$(`<span class="article__imgtxt__text">${$(this).attr("longdesc")}</span>`).insertAfter($(this));
	});
};
